module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABYUlEQVQ4jZXTTWrCQBjG8f+MJjiOEa1LF1IQV64E76ALScG1eJF24cfaO4gXaDeSkwjiygM0IBgGEky6aE1rS7S+ywd+DzMvvAJgtVq5QRA8AzUg5vpI4F1rPR+NRm9iuVy6xpjXG4jT6QRALpdLM631kzTGvNzCxhhKpRK2bWOMSfMgCF7ywMM1fDweaTabuK4LgOd5bLdbCoUCwIPkyp9/Y4BerwdAHMcAsbwHn6dcLpMkCfC50bvwer3mcDiky/xTEIYhrVYrE282G5RSaXZREEURvu8zGAwyseM4F7n8iev1OsPhkOl0+i98URCGIZ1Oh3a7Tb/fT0s8z8vEAPmfL2g0GgB0u12UUkwmE6rVaiY+F8gkSZDyex37/Z7dbketVsOyrEwMyDzgCyEeHcdhsVgQRRGWZWHb9i0M4Eul1EwIgRCCYrFIpVJBa/0fjNZ6JgC+LvKuc1ZKzcfj8dsHkpSPMXFgHGwAAAAASUVORK5CYII="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/fav-rename.png
 ** module id = 219
 ** module chunks = 0 1
 **/